var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.62,
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_710_3182",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_710_3182",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAsQAAALEBxi1JjQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAGFSURBVEiJ3dW/S9VRGAbwj5eSavEHFFG6CrmltNTUEDrUVOCkkw6B2RBR/RPZIlhbRZHQVFtTQ9KSk3D/AX9hUCJiRWK34T1xL7eLne/XO/XAgS/nfd7nOef7vryHfDzAelr3C+Rl4QZqeJdWDdfbaTCPb7iMK+l7vh3CnbiJNXHqxrWCKVTKip/FxyS2hLu4hquiBssp9h69RcV7UMUuJtDRglPBNH7iE04UMXiKPYxmcMfwC7O54gPYx1yBA70QNzmdQ74n/u1AAYOhlHMrh/wSGwXEiRp9wfPmQKsWO4nPBQ1qopVP5RhURA2KYg9Hcgzaiv/LoB8zOIevJbS2Uu4M+pqDF7AjumEVF0sYXEq5taQ13Bh8i00MlhBuxqBo8zfUf1G36ONqGwyq4ibd1Pv2NR7hg3gSD4MzOI/b1MdwBXcw7u8CHcNxbIup+Yffhe/40cRfxTM8bOAfiFFRuMmGvam0N5Ij8C8cxaIYx6+wIMbCohajoSx68URM2Q08lvlM/gaa5VbfFqEb4gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f5e663afe1dd8b816ebf711b7185a189.svg";
export { ForwardRef as ReactComponent };